import { menuService } from '@/components/application/services/menu_student_service'
import { userStore } from '@/core/stores/user'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/auth',
      component: () => import('@/components/templates/AuthTemplate.vue'),
      children: [
        {
          path: 'login',
          name: 'login',
          component: () => import('@/features/signin/presentation/pages/LoginPage.vue'),
        },
      ],
    },
    {
      path: '/',
      meta: { requiresAuth: true },
      component: () => import('@/components/templates/AppTemplate.vue'),
      children: [
        {
          path: 'history',
          name: 'Historial de talleres',
          component: () => import('@/features/history/presentation/page/HistoryPage.vue'),
          meta: { requiresTrainer: true } // Solo para no estudiantes
        },
        {
          path: 'talleres',
          name: 'talleres',
          component: () => import('@/features/workshops/presentation/pages/WorksPage.vue'),
          meta: { requiresTrainer: true }
        },
        {
          path: 'talleres/nuevo',
          name: 'NuevoTaller',
          component: () => import('@/features/workshops/presentation/organisms/Create_works.vue'),
          meta: { requiresTrainer: true }
        },
        {
          path: 'caracteristicas',
          name: 'caracteristicas',
          component: () =>
            import('@/features/characteristics/presentation/pages/CharacteristicsView.vue'),
          meta: { requiresTrainer: true }
        },
        {
          path: 'evaluaciones',
          name: 'evaluaciones',
          component: () => import('@/features/evaluations/presentation/pages/evaluations.vue'),
          meta: { requiresTrainer: true }
        },
        {
          path: 'evaluaciones/:id/detail/modify/:state',
          name: 'Detalle de evaluacion',
          component: () =>
            import('@/features/evaluations/presentation/pages/evaluation_detail.vue'),
          meta: { requiresTrainer: true }
        },
        {
          path: 'templates',
          name: 'Plantillas',
          component: () => import('@/features/templates/presentation/pages/list_template_page.vue'),
          meta: { requiresTrainer: true }
        },
        {
          path: 'templates/new',
          name: 'Crear Plantilla',
          component: () =>
            import('@/features/templates/presentation/pages/create_edit_template_page.vue'),
          meta: { requiresTrainer: true }
        },
        {
          path: 'templates/:id/edit',
          name: 'Editar Plantilla',
          component: () =>
            import('@/features/templates/presentation/pages/create_edit_template_page.vue'),
          meta: { requiresTrainer: true }
        },
        {
          path: 'student/detail_workshop/:id',
          name: 'Detalle de taller',
          component: () => import('@/features/student/presentation/pages/DetailWorkShop.vue'),
          meta: { requiresStudent: true } // Solo para estudiantes
        },
        {
          path: 'student/no-workshops',
          name: 'Sin talleres',
          component: () => import('@/features/student/presentation/pages/NoWorkshops.vue'),
          meta: { requiresStudent: true }
        }
      ],
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const userState = userStore()

  //  No autenticado → login
  if (to.meta.requiresAuth && !userState.user) {
    return next('/auth/login')
  }

  //  Usuario logueado no debe volver al login
  if (to.path.startsWith('/auth') && userState.user) {
    const user = userState.user
    
    if (user.rolId === 4) {
      // ESTUDIANTE: cargar talleres y redirigir al primero
      try {
        const response = await menuService.getAllMenu(user.id)
        
        if (response.DATA && response.DATA.length > 0) {
          return next(`/student/detail_workshop/${response.DATA[0].id}`)
        }
        
        return next('/student/no-workshops')
      } catch (error) {
        console.error('Error validando talleres:', error)
        return next('/student/no-workshops')
      }
    } else {
      // OTROS ROLES: redirigir a historial
      return next('/history')
    }
  }

  //  Proteger rutas según rol
  if (userState.user) {
    const user = userState.user
    const isStudent = user.rolId === 4

    // Si es estudiante intentando acceder a rutas de trainer
    if (isStudent && to.meta.requiresTrainer) {
      try {
        const response = await menuService.getAllMenu(user.id)
        
        if (response.DATA && response.DATA.length > 0) {
          return next(`/student/detail_workshop/${response.DATA[0].id}`)
        }
        
        return next('/student/no-workshops')
      } catch (error) {
        console.error('Error validando talleres:', error)
        return next('/student/no-workshops')
      }
    }

    // Si es trainer/admin intentando acceder a rutas de estudiante
    if (!isStudent && to.meta.requiresStudent) {
      return next('/history')
    }

    //  Entrada raíz "/" - Redirigir según rol
    if (to.path === '/') {
      if (isStudent) {
        // 🎓 ESTUDIANTE
        try {
          const response = await menuService.getAllMenu(user.id)

          if (response.DATA && response.DATA.length > 0) {
            return next(`/student/detail_workshop/${response.DATA[0].id}`)
          }

          return next('/student/no-workshops')
        } catch (error) {
          console.error('Error validando talleres:', error)
          return next('/student/no-workshops')
        }
      } else {
        // OTROS ROLES (Trainer, Admin, etc.)
        return next('/history')
      }
    }
  }

  // Navegación normal
  next()
})

export default router